import React from 'react';
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import {
  Group,
  Search,
  AddCard,
  WbSunny,
  NavigateNext,
  Download
} from '@mui/icons-material';
import AscensionCard from '../AscensionCard';
import Label from '../../../common/type/Label';
import quickLinksbg from '../../../../assets/Vector.svg';
import quickLinksbgtop from '../../../../assets/Layer_1.svg';

const QuickLinks = () => {
  const links = [
    {
      id: 'careteam',
      link: '/careteam',
      Icon: Group,
      internal: true,
      download: false
    },
    {
      id: 'findDoctor',
      link: 'https://dellchildrens.healthsparq.com/healthsparq/public/#/one/insurerCode=DCHP_I&brandCode=DCHP',
      Icon: Search,
      internal: false,
      download: false
    },
    {
      id: 'ManageIDCard',
      link: '/idCards',
      Icon: AddCard,
      internal: true,
      download: false
    },
    {
      id: 'reviewPlanCovereage',
      link: '/benefits-overview',
      Icon: WbSunny,
      internal: true,
      download: false
    }
  ];

  return (
    <AscensionCard title="Quick Links" className="box">
      <List component="nav" aria-labelledby="quick links" id="quickLinksNav">
        <div className="quick-links-header" id="quickLinksHeader">
          <div className="left-section">
            <span className="white-text"><strong><Label id="homeTitleQuickLinks"/></strong></span>
          </div>
          <div className="right-section">
          <img src={quickLinksbg} alt='Quick Links Header background' /><img src={quickLinksbgtop} alt='Quick Link Header background' id="quickLinkrightSectionImage" />
            
          </div>
        </div>
        {links.map((item, index) => (
          <ListItem
            button
            key={index}
            component="a"
            target ={!item.internal && '_blank'}
            href={item.link}
            className="quickLinksitem"
          >
            <ListItemIcon className='quickLinksIcon'>
              <item.Icon color="secondary" />
            </ListItemIcon>
            <ListItemText className='quickLinksText'>
             <strong><Label id={item.id} /></strong> 
            </ListItemText>
            {item.download ? (
              <Download color="secondary" />
            ) : (
              <NavigateNext color="secondary" />
            )}
          </ListItem>
        ))}
      </List>
    </AscensionCard>
  );
};

export default QuickLinks;
